import { countries } from "../../../../../../store/common/models";
import { VerificationDTO } from "../../../../../../store/verification/models/dto/due-diligence";

export type KycNode = {
  id: string;
  types: VerificationDTO.Responses.DueDiligence.Form.Get.T["kycs"][number]["types"];
  status: VerificationDTO.Responses.DueDiligence.Form.Get.T["kycs"][number]["details"]["userStatus"];
  fraudCheckId: string;
};
export type ParticipantNode = {
  id: string;
};

export function isKycNode(x: Node): x is KycNode {
  return (x as any).fraudCheckId !== undefined;
}

export function isCompanyNode(x: Node): x is CompanyNode {
  return (x as any).companyRegNumber !== undefined;
}

export type CompanyNode = {
  id: string;
  companyRegNumber: string;
  companyRegCountry: typeof countries.T;
};

export type Node = KycNode | CompanyNode | ParticipantNode;

export type Link = { source: string; target: string };
